var map = {
	"./de/satisfactionperceptions": [
		"smZL",
		34
	],
	"./en/satisfactionperceptions": [
		"PyMs",
		18
	],
	"./fr/satisfactionperceptions": [
		"osJI",
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4pgq";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/satisfactionperceptions$
// module id = 4pgq
// module chunks = 70